import { useAtomValue } from 'jotai';
import 'twin.macro';

import PopupInfoEl from '../popup-info-el';
import { getPopupLocationCoordinatesAtom } from '../../job-explorer-map.atoms';
import { useCombinedClusters } from './use-cluster';

export const JobPositionAndRestaurantPins = () => {
  const popupLocationCoordinates = useAtomValue(getPopupLocationCoordinatesAtom);
  const combinedClusterMarkers = useCombinedClusters();

  return (
    <>
      {combinedClusterMarkers}
      {!!popupLocationCoordinates?.id && (
        <div tw="md:hidden absolute bottom-[10%] md:(relative bottom-[unset]) w-full flex justify-center">
          <PopupInfoEl />
        </div>
      )}
    </>
  );
};
